import React, { useEffect, useState, useRef } from "react";
import "./HotelForm.css";
import { Accordion, Col, Row } from "react-bootstrap";
import hotelsIcon from "../../../../assets/images/packages/svg/hotel.svg";
import {
  ErrorPopUp,
  SingleCalendar,
  SpinnerLoading,
} from "../../../../components";
import { axiosGet, axiosPost, axiosPut } from "../../../../utils/apis/api";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { useTranslation } from "../../../../contexts/TranslationContext";

const HotelForm = ({
  url,
  onReturn,
  onSuccess,
  package_name,
  selectedDates,
  selectedDestination,
  package_component_id,
  Refresh,
  setItems
}) => {
  // const [rooms, setRooms] = useState([{ adults: 1, children: 0, children_ages: [] }]);
  const [isLoading, setIsLoading] = useState(false);

  const [hotelReservation, setHotelReservation] = useState({
    quotation_id: package_name,
    check_in: null,
    check_out: null,
    destination_city: null,
    destination_city_name: null,
    destination_country:null,
    destination_country_name: null,
    hotel_name: null,
    hotel_location: null,
    contact_person_at_destination: null,
    already_reserved: true,
    confirmation: null,
    quotation_item_date_from: null,
    quotation_item_date_to: null,
    quotation_item_destination: selectedDestination.location,
    quotation_item_destination_row_id: selectedDestination.primary_destination_row_id,
  });
  const PAGE_LIMIT = 50;
  const [countries, setCountries] = useState([]);
  const [reservationDetails, setReservationDetails] = useState();
  const [hasMoreCountries, setHasMoreCountries] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorPopUp, setErrorPopUp] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const destinationCountryRef = useRef(null);
  const destinationCityRef = useRef(null);
  const hotelCheckInRef = useRef(null);
  const hotelCheckOutRef = useRef(null);
  const hotelNameRef = useRef(null);
  const contactDestRef = useRef(null);
  const hotelLocationRef = useRef(null);
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const [locationInputValue, setLocationInputValue] = useState(
    selectedDestination.location_type === "City"
      ? selectedDestination.location_name
      : ""
  );
  const [countryInputValue, setCountryInputValue] = useState(
    selectedDestination.location_type === "Country"
      ? selectedDestination.location_name
      : ""
  );
  const formattedStart = selectedDates?.startDate
    ? dayjs(selectedDates.startDate).format("MMM D")
    : null;

  const formattedEnd = selectedDates?.endDate
    ? dayjs(selectedDates.endDate).format("MMM D")
    : null;

  const [cities, setCities] = useState([]);
  const [hasMoreCities, setHasMoreCities] = useState(true);
  const phoneRegex = /^\+?[0-9]{6,15}$/;

  const fetchCities = async (search = "", start = 0, append = false) => {
    if (!hasMoreCities && append) return;
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search,
          start,
          limit: PAGE_LIMIT,
          location_type: "City",
        }
      );

      const newItems = response.result?.locations || [];
      setCities((prev) => (append ? [...prev, ...newItems] : newItems));
      setHasMoreCities(newItems.length === PAGE_LIMIT);
    } catch (err) {
      console.error("City fetch error:", err);
      setCities([]);
    }
  };

  const fetchCountries = async (search = "", start = 0, append = false) => {
    if (!hasMoreCountries && append) return;
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        {
          search,
          start,
          limit: PAGE_LIMIT,
          location_type: "Country",
        }
      );

      const newItems = response.result?.locations || [];
      setCountries((prev) => (append ? [...prev, ...newItems] : newItems));
      setHasMoreCountries(newItems.length === PAGE_LIMIT);
    } catch (err) {
      console.error("Country fetch error:", err);
      setCountries([]);
    }
  };

  const handleClickButton = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!hotelReservation.check_in) {
      newErrors.check_in = t("CheckInRequired");
    }
    if (!hotelReservation.check_out) {
      newErrors.check_out =  t("CheckOutRequired");
    }
    if (!hotelReservation.hotel_name) {
      newErrors.hotel_name =  t("HotelNameRequired");
    }
    if (!hotelReservation.hotel_location) {
      newErrors.hotel_location =  t("HotelLocationRequired");
    }
    if (!hotelReservation.destination_country) {
      newErrors.destination_country =  t("DestinationCountryRequired");
    }
    if (!hotelReservation.destination_city) {
      newErrors.destination_city =  t("DestinationCityRequired");
    }
    if ( hotelReservation.contact_person_at_destination && !phoneRegex.test(hotelReservation.contact_person_at_destination)) {
      newErrors.contact_person = t("InvalidPhoneNumberFormat");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      if (errors.destination_country && destinationCountryRef.current) {
        destinationCountryRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        destinationCountryRef.current.focus();
      }

      if (errors.destination_city && destinationCityRef.current) {
        destinationCityRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        destinationCityRef.current.focus();
      }

      if (errors.check_in && hotelCheckInRef.current) {
        hotelCheckInRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        hotelCheckInRef.current.focus();
      } else if (errors.check_out && hotelCheckOutRef.current) {
        hotelCheckOutRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        hotelCheckOutRef.current.focus();
      } else if (errors.hotel_name && hotelNameRef.current) {
        hotelNameRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        hotelNameRef.current.focus();
      } else if (errors.hotel_location && hotelLocationRef.current) {
        hotelLocationRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        hotelLocationRef.current.focus();
      }
      else if (errors.contact_person && contactDestRef.current) {
        contactDestRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        contactDestRef.current.focus();
      }
      return;
    }
    setLoading(true);

    // No errors: proceed with submission
    setErrors({});

    const payload = { ...hotelReservation };

    if (package_component_id) {
      payload["reservation_id"] = package_component_id;
      payload["row_id"] = reservationDetails.quotation_item_id;
    }
    if (payload.destination_city_name) {
      delete payload.destination_city_name;
    }
    if (payload.destination_country_name) {
      delete payload.destination_country_name;
    }
      const isUnValid = dayjs(hotelReservation.check_in).isSameOrAfter(hotelReservation.check_out);
      
      if (isUnValid) {
        setErrorMessage(
          t("CheckInDateMustBeEarlierThanCheckOutDate")
        );
        setErrorPopUp(true);
        setLoading(false);
        return;
      
    }

    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      var response;

      if (package_component_id) {
        response = await axiosPut(
          `${url}/api/method/alltimes.www.api.update_hotel_reservation`,
          payload,
          headers
        );
      } else {
        response = await axiosPost(
          `${url}/api/method/alltimes.www.api.add_hotel_reservation`,
          payload,
          headers
        );
      }

      if (response.status === 200) {
        if (package_component_id) {
          toast.success( t("YourReservationHasBeenUpdated"),{
            position: "bottom-right",
          });
        } else {
          toast.success( t("YourReservationHasBeenAdded"),{
            position: "bottom-right",
          });
        }
        setLoading(false);

        onSuccess();
        if(!package_component_id){
          Refresh();
        }
        else{
          let result = response.data?.result;
          if(result){
            setItems(result.items??[]);
          }
        }
      } else {
        setErrorPopUp(true);
        // toast.error(response.message??`Error occurred while ${package_component_id ? "updating" : "adding"} your reservation, please contact support!`, {
        //   position: 'bottom-right',
        // });
        let message= ""

        if(package_component_id){
          message = t("ErrorOccurredWhileUpdatingReservation");
        }
        else{
          message = t("ErrorOccurredWhileAddingReservation");
        }
        setErrorMessage(
          response.message ??
            message
        );
        setLoading(false);
      }
    } catch (error) {
      setErrorPopUp(true);
      let errorMessage = error.message.replace(/^Error:\s*/, "");
      if(error){
        if(error.response?.data?.message){
          errorMessage = error.response?.data?.message
        }
      }
      let message= ""
      if(package_component_id){
        message = t("ErrorOccurredWhileUpdatingReservation");
      }
      else{
        message = t("ErrorOccurredWhileAddingReservation");
      }

      setErrorMessage(
        errorMessage ??
          message
      );
      // toast.error(error.toString()??`Error occurred while ${package_component_id ? "updating" : "adding"} your reservation, please contact support!`, {
      //   position: 'bottom-right',
      // });
      setLoading(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // fetchLocations();
    // fetchCountries();
  }, []);

  useEffect(() => {
    setHotelReservation((prev) => ({
      ...prev,
      destination_city:
        selectedDestination.location_type === "City"
          ? selectedDestination.location
          : null,
      destination_city_name:
        selectedDestination.location_type === "City"
          ? selectedDestination.location_name
          : null,
      destination_country:
        selectedDestination.location_type === "Country"
          ? selectedDestination.location
          : selectedDestination.location_type === "City"
          ? selectedDestination.parent_location
          : null,
      destination_country_name:
        selectedDestination.location_type === "Country"
          ? selectedDestination.location_name
          : selectedDestination.location_type === "City"
          ? selectedDestination.parent_location_name
          : null,
    }));

    setLocationInputValue(selectedDestination.location_type === "City"
      ? selectedDestination.location_name
      : "");

    setCountryInputValue(selectedDestination.location_type === "Country"
      ? selectedDestination.location_name:
      selectedDestination.location_type === "City"
      ? selectedDestination.parent_location_name
      : 
      "");
  
  }, [selectedDestination]);


  const fetchReservationDetails = async () => {
    try {
      let apiUrl = `${url}/api/method/alltimes.www.api.hotel_reservation_details?quotation_id=${package_name}&reservation_id=${package_component_id}`;

      setIsLoading(true);
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosGet(apiUrl, {}, headers);

      const result = response.result[0];
      if (result) {
        setReservationDetails(result);

        setHotelReservation({
          quotation_id: result.quotation_id,
          check_in: result.check_in,
          check_out: result.check_out,
          destination_city: result.destination_city,
          destination_city_name: result.destination_city_name,
          destination_country: result.destination_country,
          destination_country_name: result.destination_country_name,
          hotel_name: result.hotel_name,
          hotel_location: result.hotel_location,
          contact_person_at_destination: result.contact_person_at_destination,
          already_reserved: result.already_reserved,
          confirmation: result.confirmation,
          quotation_item_date_from: result.check_in ?? null, //selectedDates.startDate ? dayjs(selectedDates.startDate).format('YYYY-MM-DD HH:mm:ss') : null,
          quotation_item_date_to: result.check_out ?? null, // start Date For Quotation Component
          quotation_item_destination: selectedDestination.location,
          quotation_item_destination_row_id: selectedDestination.primary_destination_row_id,
        });
        setLocationInputValue(result.destination_city_name);
        setCountryInputValue(result.destination_country_name);
        setIsLoading(false);
      }
      else {
        setLocationInputValue(null);
        setCountryInputValue(null);
        setReservationDetails(null);
        setIsLoading(false);
        // throw new Error(response.exc || "Something went wrong");
      }
    } catch (error) {
      setIsLoading(false);
      return { data: null, error: error.message };
    }
  };

  useEffect(() => {
    if (package_component_id) {
      fetchReservationDetails();
    }
  }, [package_component_id]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <SpinnerLoading />
      </div>
    );
  }

  return (
    <div className="hotel-form-container">
      <button className="hotel-form-backbtn" onClick={onReturn}>
        {Lang === "ar" ? (
          <>
            {t("BackToPlan")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("BackToPlan")}
          </>
        )}
      </button>
      <div className="hotel-form-title">
        <div className="hotel-form-title-icon">
          <img src={hotelsIcon} alt="hotel" />
        </div>
        <div>{t("AddHotelManually")}</div>
      </div>
      <div className="hotel-form-date">
        {formattedStart} - {formattedEnd} , {t("In")} {" "}
        <span>{selectedDestination.location_name}</span>
      </div>
      <Accordion
        defaultActiveKey="0"
        className="hotel-form-accordion"
        alwaysOpen
      >
        <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            1. {t("HotelBookingDetails")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("DestinationCity")} <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    ref={destinationCityRef}
                    style={{ width: "100%" }}
                    options={cities || []}
                    getOptionLabel={(option) => option?.location_name || ""}
                    value={
                      hotelReservation.destination_city
                        ? {
                            name: hotelReservation.destination_city,
                            location_name:
                              hotelReservation.destination_city_name, 
                          }
                        : null
                    }
                    inputValue={locationInputValue}
                    onChange={(event, newValue) => {
                      setHotelReservation((prev) => ({
                        ...prev,
                        destination_city: newValue?.name || null,
                        destination_city_name: newValue?.location_name || null,
                      }));
                      setLocationInputValue(newValue?.location_name || "");
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setLocationInputValue(newInputValue);
                        fetchCities(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchCities();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("DestinationCity")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.name}>
                        {option.location_name}
                      </li>
                    )}
                  />

                  {errors.destination_city &&
                    !hotelReservation.destination_city && (
                      <div className="invalid-feedback">
                        {errors.destination_city}
                      </div>
                    )}
                  {/* <input type='text' className='hotel-form-input' placeholder='Search' /> */}
                </div>
              </Col>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("DestinationCountry")}
                    <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    ref={destinationCountryRef}
                    style={{ width: "100%" }}
                    options={countries || []}
                    getOptionLabel={(option) => option?.location_name || ""}
                    value={
                      hotelReservation.destination_country
                        ? {
                            name: hotelReservation.destination_country,
                            location_name:
                              hotelReservation.destination_country_name,
                          }
                        : null
                    }
                    inputValue={countryInputValue}
                    onChange={(event, newValue) => {
                      setHotelReservation((prev) => ({
                        ...prev,
                        destination_country: newValue?.name || null,
                        destination_country_name:
                          newValue?.location_name || null,
                      }));
                      setCountryInputValue(newValue?.location_name || "");
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setCountryInputValue(newInputValue);
                        fetchCountries(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchCountries();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("DestinationCountry")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "13px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.name}>
                        {option.location_name}
                      </li>
                    )}
                  />

                  {errors.destination_country &&
                    !hotelReservation.destination_country && (
                      <div className="invalid-feedback">
                        {errors.destination_country}
                      </div>
                    )}
                </div>
              </Col>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("CheckInDate")} <span>*</span>
                  </label>
                  <SingleCalendar
                    placeholder={t("CheckInDate")}
                    value={
                      hotelReservation.check_in
                        ? new Date(hotelReservation.check_in)
                        : null
                    }
                    onChange={(e) =>
                      setHotelReservation((prev) => ({
                        ...prev,
                        check_in:
                          e?.value != null
                            ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss")
                            : null,
                        quotation_item_date_from:
                          e?.value != null
                            ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss")
                            : null,
                      }))
                    }
                    dateRef={hotelCheckInRef}
                    min={new Date(selectedDates.startDate)}
                    max={
                      hotelReservation.check_out
                        ? new Date(
                            Math.min(
                              new Date(hotelReservation.check_out).getTime(),
                              new Date(selectedDates.endDate).getTime()
                            )
                          )
                        : new Date(selectedDates.endDate)
                    }
                    viewDate={new Date(selectedDates.startDate)}
                  />
                </div>
                {errors.check_in && !hotelReservation.check_in && (
                  <div className="invalid-feedback">{errors.check_in}</div>
                )}
              </Col>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("CheckOutDate")} <span>*</span>
                  </label>
                  <SingleCalendar
                    placeholder={t("CheckOutDate")}
                    value={
                      hotelReservation.check_out
                        ? new Date(hotelReservation.check_out)
                        : null
                    }
                    onChange={(e) =>
                      setHotelReservation((prev) => ({
                        ...prev,
                        check_out:
                          e?.value != null
                            ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss")
                            : null,
                        quotation_item_date_to:
                          e?.value != null
                            ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss")
                            : null,
                      }))
                    }
                    dateRef={hotelCheckOutRef}
                    min={
                      hotelReservation.check_in
                        ? new Date(
                            Math.max(
                              new Date(hotelReservation.check_in).getTime(),
                              new Date(selectedDates.startDate).getTime()
                            )
                          )
                        : new Date(selectedDates.startDate)
                    }
                  


                    max={new Date(selectedDates.endDate)}
                    viewDate={new Date(selectedDates.endDate)}
                  />
                </div>
                {errors.check_out && !hotelReservation.check_out && (
                  <div className="invalid-feedback">{errors.check_out}</div>
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            2. {t("HotelContacts")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("HotelName")} <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="hotel-form-input"
                    placeholder={t("AddHotelName")}
                    value={hotelReservation.hotel_name}
                    onChange={(val) =>
                      setHotelReservation((prev) => ({
                        ...prev,
                        "hotel_name": val.target.value,
                      }))
                    }
                    ref={hotelNameRef}
                  />
                </div>
                {errors.hotel_name && !hotelReservation.hotel_name && (
                  <div className="invalid-feedback">{errors.hotel_name}</div>
                )}
              </Col>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("HotelLocation")} <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="hotel-form-input"
                    placeholder={t("AddHotelLocation")}
                    value={hotelReservation.hotel_location}
                    onChange={(val) =>
                      setHotelReservation((prev) => ({
                        ...prev,
                        "hotel_location": val.target.value,
                      }))
                    }
                    ref={hotelLocationRef}
                  />
                </div>
                {errors.hotel_location && !hotelReservation.hotel_location && (
                  <div className="invalid-feedback">
                    {errors.hotel_location}
                  </div>
                )}
              </Col>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("Confirmation")}
                  </label>
                  <input
                    type="text"
                    className="hotel-form-input"
                    placeholder={t("AddConfirmation")}
                    value={hotelReservation.confirmation}
                    onChange={(val) =>
                      setHotelReservation((prev) => ({
                        ...prev,
                        "confirmation": val.target.value,
                      }))
                    }
                  />
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            3. {t("TravelAndContactDetails")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              <Col xl={3} md={4}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("ContactPersonAtDestination")}
                  </label>
                  <input
                    type="tel"
                    ref={contactDestRef}
                    inputMode="tel"
                    // pattern="[0-9+ ]*"
                    // maxLength={15}
                    className="hotel-form-input"
                    placeholder={t("AddContactPerson")}
                    value={hotelReservation.contact_person_at_destination}
                    onChange={(val) =>
                    {
                      // if (/^[0-9+ ]*$/.test(val.target.value)) {
                        setHotelReservation((prev) => ({
                          ...prev,
                          contact_person_at_destination: val.target.value,
                        }));
                      // }
                    }
                    }
                  />
                   {errors.contact_person && !phoneRegex.test(hotelReservation.contact_person_at_destination) && hotelReservation.contact_person_at_destination && (
                        <div className="invalid-feedback">{errors.contact_person}</div>
                      )}
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <button
        className={`hotel-form-addbtn ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={(e) => {
          if (!loading) {
            handleClickButton(e);
          }
        }}
        disabled={loading}
      >
        {loading
          ? t("Loading") + "..."
          : package_component_id
          ? t("UpdateHotelReservation")
          : t("AddHotelReservation")}
      </button>

      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
      <ErrorPopUp
        message={errorMessage}
        showpopUp={errorPopUp}
        handleClose={() => {
          setErrorPopUp(false);
          setErrorMessage(null);
        }}
      />
    </div>
  );
};

export default HotelForm;
